import { FC } from 'react';
import { css } from '@emotion/react';
import { useTaskCenterStore } from '@frontend/task-center-scope';
import { CreateOrUpdateTask } from './create-task/create-task';

export const TaskModeRenderer: FC = () => {
  const { taskMode } = useTaskCenterStore(['taskMode']);

  if (taskMode !== null) {
    return (
      <div css={containerStyles}>
        <CreateOrUpdateTask />
      </div>
    );
  }
  return null;
};

const containerStyles = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
